/**
 * Copyright © Veeam Software Group GmbH.
 */

import { action, observable, makeObservable } from 'mobx';
import { AmazonObjectType } from '@veeam-vspc/models/web-controllers';

export class ProtectedAwsWorkloadsStore {

    @observable amazonObjectType: AmazonObjectType;

    constructor(type: AmazonObjectType, readonly lsStateId: string) {
        makeObservable(this);
        this.amazonObjectType = type;
    }

    @action.bound
    setAmazonObjectType(v: AmazonObjectType): void {
        this.amazonObjectType = v;
    }
}
